import { getEnv } from "../../config/getEnv";
import { tryRecoverFrom401 } from "./backend401Recovery";

const BE_URL = getEnv("REACT_APP_BE_URL") || "http://localhost:8080";

function redirectToLoginAfterSessionLoss() {
  if (typeof window === "undefined") return;
  const current = window.location.pathname + window.location.search;
  if (!current.startsWith("/login")) {
    window.location.assign("/login?error=session_expired");
  }
}

function getHeaders(includeBody = false) {
  const headers = {};
  if (includeBody) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}

/**
 * Backend API: HttpOnly cookies only (azure_access_token). No Authorization Bearer from JS.
 * On 401, tryRecoverFrom401 runs MSAL acquireTokenSilent (uses refresh token in MSAL cache)
 * and syncAzureTokenCookies to repopulate cookies.
 */
async function beFetch(path, init) {
  const url = `${BE_URL}${path}`;
  let response = await fetch(url, init);

  if (response.status === 401) {
    const recovered = await tryRecoverFrom401();
    if (recovered) {
      const retryInit = {
        ...init,
        headers: { ...init.headers, ...getHeaders(Boolean(init.body)) },
      };
      response = await fetch(url, retryInit);
    } else {
      redirectToLoginAfterSessionLoss();
      throw new Error("Unauthorized");
    }
  }

  return response;
}

async function parseJsonResponse(response) {
  const body = await response.json().catch(() => ({ error: response.statusText }));
  if (!response.ok) {
    const message =
      (typeof body.error === "string" && body.error) ||
      (body.error && typeof body.error.message === "string" && body.error.message) ||
      body.message ||
      `HTTP ${response.status}: ${response.statusText}`;
    throw new Error(message);
  }
  return body;
}

export const api = {
  get: async (url) => {
    const response = await beFetch(url, {
      method: "GET",
      headers: getHeaders(),
      credentials: "include",
    });
    return parseJsonResponse(response);
  },
  post: async (url, data) => {
    const response = await beFetch(url, {
      method: "POST",
      headers: getHeaders(true),
      body: JSON.stringify(data),
      credentials: "include",
    });
    return parseJsonResponse(response);
  },
  put: async (url, data) => {
    const response = await beFetch(url, {
      method: "PUT",
      headers: getHeaders(true),
      body: JSON.stringify(data),
      credentials: "include",
    });
    return parseJsonResponse(response);
  },
  delete: async (url) => {
    const response = await beFetch(url, {
      method: "DELETE",
      headers: getHeaders(),
      credentials: "include",
    });
    return parseJsonResponse(response);
  },
};
